import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { login } from '../redux/actions/auth.action';

export default function LoginPage() {
    const { error } = useSelector(state => state.login);
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isEmailTouched, setIsEmailTouched] = useState(false);
    const [isPasswordTouched, setIsPasswordTouched] = useState(false);

    const [URLSearchParams] = useSearchParams();
    const redirect_to = URLSearchParams.get('redirect_to');
    
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(login(email, password, redirect_to, navigate));
    }

    useEffect(() => {
        if(jwt_access){
            navigate(redirect_to ? redirect_to : '/');
        }
    }, [location, navigate, jwt_access, redirect_to]);

    return (
        !me &&
        <HelmetProvider>
            <Helmet>
                <title>Connexion - Société Mikalo</title>
            </Helmet>
            <div id="authLogin">
                <form className='form login-form' onSubmit={ handleSubmit }>
                    <div className='login-form-logo'>
                        <img src="/images/logo.png" alt="" />
                    </div>

                    <div className='title'>
                        <h1>Connexion</h1>
                    </div>
                    { error && <div className='alert alert-danger'>{ error }</div> }
                    <div className='mb-3'>
                        <label htmlFor='email' className='required'>E-mail</label>
                        <input type='email' id='email' name='email' value={ email } onChange={ (e) => setEmail(e.target.value) } onBlur={ () => setIsEmailTouched(true) } className='form-control' placeholder='E-mail' required autoComplete='off' />
                        { isEmailTouched && email.length === 0 && <div className='form-error'>Veuillez saisir votre e-mail.</div> }
                        { isEmailTouched && email.length > 0 && /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false && <div className='form-error'>Votre e-mail n'est pas valide.</div> }
                    </div>
                    <div className='mb-3'>
                        <label htmlFor='password' className='required'>Mot de passe</label>
                        <input type='password' id='password' name='password' value={ password } onChange={ (e) => setPassword(e.target.value) } onBlur={ () => setIsPasswordTouched(true) } className='form-control' placeholder='Mot de passe' required autoComplete='off' />
                        { isPasswordTouched && password.length === 0 && <div className='form-error'>Veuillez saisir votre mot de passe.</div> }
                        { isPasswordTouched && password.length > 0 && password.length < 8 && <div className='form-error'>Votre mot de passe n'est pas valide.</div> }
                    </div>
                    <div className='mb-3 text-end'>
                        <Link to="/forgot-password">Mot de passe oublié ?</Link>
                    </div>
                    <div className='pt-1'>
                        <button type='submit' className='btn btn-primary w-100 btn-lg' disabled={
                            /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false || password.length < 8
                        }>Se connecter</button>
                    </div>
                </form>
            </div>
        </HelmetProvider>
    )
}
